import { green, orange, red, blue } from "@material-ui/core/colors";
export const timeStatus = {
  ON_TIME: {
    value: "ON_TIME",
    menu: "ON_TIME",
    style: "status-on_route",
    translate: "A Tiempo",
    color: green[500],
    bgColor: green[100]
  },
  DELAYED: {
    value: "DELAYED",
    menu: "DELAYED",
    style: "status-transmitted",
    translate: "Demorado",
    color: orange[500],
    bgColor: orange[100]
  },
  LATE: {
    value: "LATE",
    menu: "LATE",
    style: "status-cancelled",
    translate: "Retrasado",
    color: red[500],
    bgColor: red[100]
  },
  FINISHED: {
    value: "FINISHED",
    menu: "FINISHED",
    style: "status-captured",
    translate: "Programado",
    color: blue[500],
    bgColor: blue[100]
  },
  N_A: {
    value: "N_A",
    menu: "N_A",
    style: "status-captured",
    translate: "N/A",
    color: '#fff',
    bgColor: '#fff'
  }
};

export const timeStatusItemsRequests = {
  APPROVED: {
    value: "APPROVED",
    menu: "APPROVED",
    style: "status-on_route",
    translate: "Aprobado",
    color: green[500],
    bgColor: green[100]
  },
  IN_ORACLE: {
    value: "IN_ORACLE",
    menu: "IN ORACLE",
    style: "status-on_route",
    translate: "En Oracle",
    color: green[500],
    bgColor: green[100]
  },
  PARTIALLY_IN_ORACLE: {
    value: "PARTIALLY_IN_ORACLE",
    menu: "PARTIALLY IN ORACLE",
    style: "status-transmitted",
    translate: "Parcialmente en Oracle",
    color: orange[500],
    bgColor: orange[100]
  },
  REJECTED: {
    value: "REJECTED",
    menu: "REJECTED",
    style: "status-cancelled",
    translate: "Rechazado",
    color: red[500],
    bgColor: red[100]
  },
  PENDING: {
    value: "PENDING",
    menu: "PENDING",
    style: "status-captured",
    translate: "Pendiente",
    color: blue[500],
    bgColor: blue[100]
  },
};

export const routesStatus = {
  OPEN: {
    value: "OPEN",
    menu: "OPEN",
    style: "status-open",
    translate: "Abierta",
    color: green[500],
    bgColor: green[100]
  },
  NO_STATUS: {
    value: "NO_STATUS",
    menu: "NO_STATUS",
    style: "no-status",
    translate: "Sin estatus",
    color: red[500],
    bgColor: red[100]
  },
  CLOSED: {
    value: "CLOSED",
    menu: "CLOSED",
    style: "status-closed",
    translate: "Cerrada",
    color: blue[500],
    bgColor: blue[100]
  },
};